// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1nh7L","search":"Settings_search__2mql1","filter":"Settings_filter__2z4ba"};